import { offerService } from 'services/offer.service'
import { useContext, useEffect, useMemo } from 'external/react'

import Admin from 'context/admin-context'

import useFormValidation, {validators} from 'utilities/form-validation'
import useAuth from 'context/auth-context/hook'
import { adminService } from 'services/admin.service'
import getName from 'utilities/enum'

const {createRequiredFieldValidation, createConditionallyRequiredFieldValidation} = validators

const changeValidations = {
	name: [createRequiredFieldValidation('name')],
	price: [createRequiredFieldValidation('price')],
	discount_name: [createRequiredFieldValidation('discount_name')],
    discount_amount: [createRequiredFieldValidation('discount_amount')],
    month_number: [createConditionallyRequiredFieldValidation('month_number', (offer) => offer.duration === 'repeating')]
}

export default function useAdmin() {

    const {user} = useAuth()
	const {state, update} = useContext(Admin.Context)
    const {currentOffer, offers: { initialized: initializedOffers, items: offers }, props: {navigation, params, query}, changeCourseModal} = state

	const [errors, validate, resetValidations] = useFormValidation(changeValidations)

    const toggleOfferStatus = (offer) => {
        const offerIndex = state.offers.items.findIndex((item:any) => item.id === offer.id)
        if (offerIndex >= 0) {
            update({offers: {items: {[offerIndex]: {active: {$apply: current => {
                const active = !current
                offerService.updateOfferActive({...offer, active})
                return active
            }}}}}})
        }
    }

    const updateChangeCourseModal = async (open, purchaseIndex, originalCourse, {subject, grade, course, source}, cb) => {
        await update({changeCourseModal: {open: {$set: open},
         purchaseIndex: {$set: purchaseIndex},
         originalCourse: {$set: originalCourse},
         source: {$set: source},
         selected: {subject: {$set: subject},
             grade: {$set: grade},
             course: {$set: course}
        }}})
        cb && cb(open, purchaseIndex, {subject, grade, course})
    }

    const changeClientCourse = async (params) => {
        try {
            const resp = await adminService.updateClientCourse(user.id, params)
            console.log(resp)
            //window.location.reload()
        } catch(err) {
            console.log(err)
        }
    }
    
    const getStripeInfo = async (clientId) => {
        return adminService.getStripeInfo(user.id, clientId)
    }

    const roleName = useMemo(() => (user ? getName('role', user.role) : '')?.toLowerCase(), [user.role])

    return {
        offers,
        roleName,
        currentOffer,
        toggleOfferStatus,
        initializedOffers,
        state,
        update,
        params,
        query,
        navigation,
        errors,
        validate,
        changeCourseModal,
        updateChangeCourseModal,
        changeClientCourse,
        getStripeInfo,
        resetValidations
    }

}